import { Location } from 'history';
import { ActivitiesPageTypes } from 'core/constant/analytics/AnalyticsPageType';

/*
 * Please keep SearchPageType enum in sync with SearchType enum in file below.
 * https://gitlab.agodadev.io/full-stack/fe-data/messaging-client-messages/-/blob/master/src/MessagingClient.Messages/Enums/SearchType.cs?ref_type=heads
 */
export enum SearchPageType {
    None = 0, // when its not search page
    City = 1, // when its city search page without keyword
    InCityText = 23, // when its city search page with keyword,
    TextSearch = 24, // when its only keyword and no geo id a.k.a GlobalKeywordSearch
    Geolocation = 25, // when its based on lat-long
}

export interface NavigationState {
    location?: Location;
    isMobile: boolean;
    cid: number;
    ssoUrl: string;
    pageTypeId: ActivitiesPageTypes;
    isGlobalKeywordSearchPage: boolean;
    previousPageTypeId?: ActivitiesPageTypes;
    searchPageType: SearchPageType;
}
